import React, { FC, ReactElement } from 'react'

import { definitions } from 'api/generated/photo'
import { Wrapper } from 'components/page/PhotoViewer/Panel/PanelBottom/PanelBottom.styled'
import { PhotoCounterLike } from 'components/page/PhotoViewer/PhotoCounterLike'
import { ItemPanel } from 'components/presentational/panel/ItemPanel'

interface PanelBottomViewProps {
  photo: definitions['OmniAlbumPhoto']
  shareButton: ReactElement | null
  isCurrentUser: boolean
}

export const PanelBottomView: FC<PanelBottomViewProps> = ({
  photo,
  shareButton,
  isCurrentUser,
}) => {
  return (
    <Wrapper>
      <ItemPanel
        start={
          <PhotoCounterLike
            photoId={photo.photoId}
            counterLike={photo.likes}
            canVoting={!photo.voted && !isCurrentUser}
            votable={photo.voteable}
            liked={photo.liked}
            dark={true}
          />
        }
        end={shareButton}
      />
    </Wrapper>
  )
}
